import { EntityType } from '@/models/logs.model';
import { useAppDispatch, useAppState } from '@/store';
import { useEffect, useMemo } from 'react';
import { GetActionLogsDTO } from '../dtos';
import {
  getActionLogs,
  resetLogsState,
  selectActionLogs,
  selectLogsError,
  selectLogsIsLoading,
  selectPagination,
} from '../feature';

export const useGetActionLogs = (id: string, entityType: EntityType = EntityType.ORDER) => {
  const dispatch = useAppDispatch();
  const actionLogs = useAppState(selectActionLogs);
  const isLoading = useAppState(selectLogsIsLoading);
  const pagination = useAppState(selectPagination);
  const error = useAppState(selectLogsError);

  useEffect(() => {
    if (!id || !entityType) return;
    const dto = new GetActionLogsDTO({ id, entityType });
    dispatch(getActionLogs(dto));
  }, [dispatch, id, entityType]);

  useEffect(() => {
    return () => {
      dispatch(resetLogsState());
    };
  }, [dispatch]);

  return useMemo(() => ({ actionLogs, isLoading, pagination, error }), [actionLogs, isLoading, pagination, error]);
};
